export default __webpack_public_path__ + "static/updatesBlock-2147b013ec95f672c87abc110b3d3258.png";